<style>
  .support-index .st-body .ticket-content .ticket-description{
    height: auto;
  }
  
  .status-pill.green.pulse {
    animation: pulse-green 1.5s infinite;
  }
  @keyframes pulse-green {
    0% { box-shadow: 0 0 0 0 rgba(139, 195, 74, 0.8); }
    70% { box-shadow: 0 0 0 8px rgba(139, 195, 74, 0); }
    100% { box-shadow: 0 0 0 0 rgba(139, 195, 74, 0); }
  }

  .status-pill.red.pulse {
    animation: pulse-red 1.5s infinite;
  }
  @keyframes pulse-red {
    0% { box-shadow: 0 0 0 0 rgba(230, 82, 82, 0.8); }
    70% { box-shadow: 0 0 0 8px rgba(230, 82, 82, 0); }
    100% { box-shadow: 0 0 0 0 rgba(230, 82, 82, 0); }
  }

  .status-pill.dark.pulse {
    animation: pulse-dark 1.5s infinite;
  }
  @keyframes pulse-dark {
    0% { box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.8); }
    70% { box-shadow: 0 0 0 8px rgba(52, 58, 64, 0); }
    100% { box-shadow: 0 0 0 0 rgba(52, 58, 64, 0); }
  }
</style>
<template>
  <div class="white_gradient_bg_light shadow_inset_lg mb-3" @click="seleccionar">
    <div class="row m-0 align-items-center w-100">
      <div class="col-3 text-center p-0">
        <i class="fas fa-file-invoice" style="font-size: 3rem; color: #aeaeae;"></i>
      </div> 
      <div class="col-9 p-0">
        <div class="py-3 mx-3">
          <div class="ticket-content">
            <div class="d-flex justify-content-between align-items-center mb-1">
              <h6 class="ticket-title m-0">
                {{ facturae.serie }} - {{ facturae.documento }}
              </h6>
              <div class="st-meta m-0 position-relative" style="right: 0; top: 0; transform: none;">
                <i class="os-icon os-icon-unlock" v-if="facturae.estado == 'A'"></i>
                <i class="os-icon os-icon-lock" v-if="facturae.estado == 'B'"></i>
                <i class="os-icon os-icon-lock" v-if="facturae.estado == '9'"></i>
                <i class="os-icon os-icon-lock" v-if="facturae.estado == 'C'"></i>
                <div class="status-pill green pulse" v-if="facturae.estado == 'A'"></div>
                <div class="status-pill red pulse" v-if="facturae.estado == 'B'"></div>
                <div class="status-pill red pulse" v-if="facturae.estado == '9'"></div>
                <div class="status-pill dark pulse" v-if="facturae.estado == 'C'"></div>
              </div>
            </div>
            <div class="ticket-description">
              {{ facturae.proveedor }} - {{ facturae.proveedor_obj.nombre }}
            </div>
            <div class="d-flex justify-content-between mt-2">
              <div class="text-left w-50">
                <b>Nit:</b><span class="value text-success font-weight-bold">
                  {{ facturae.proveedor_obj.nit }}
                </span>
              </div>
              <div class="text-right w-50">
                <b>Q.</b><span class="value text-success font-weight-bold">
                  {{ Intl.NumberFormat('en-GB', {}).format(facturae.total_documento) }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  components: {},
  data() {
    return {};
  },
  props: ["facturae"],
  computed: {},
  mounted() {},
  methods: {
    ...mapActions({
      selectInvoice: 'recepciones/selectInvoice'
    }),
    seleccionar() {
      let self = this;
      self.selectInvoice(self.facturae);
      self.$emit("seleccion", self.facturae.id);
    },
  },
};
</script>
